import { DropSettingsSimple } from './model/drop-settings-simple.model';
import { Injectable } from '@angular/core';
import { ApiService } from './../../shared/api/api.service';
import { DropMemberResult } from './model/drop-member-result.model';
import { BatchDropRequestParamsDto } from './dto/batch-drop-request-params.dto';
import { QueryStringParamService } from 'src/app/shared/http/query-string-param.service';
import { BatchDropRequestDto } from './dto/batch-drop-request.dto';
import { PagedResult, PagedResultGeneric } from 'src/app/shared';
import { AuthService } from '../../shared/auth/auth.service';
import { MemberDropValidationResultDto } from './member-drop-validation-result.dto';

@Injectable({
  providedIn: 'root',
})
export class ProfileDropMemberService {
  private _apiService: ApiService;

  constructor(
    apiService: ApiService,
    private _queryStringParamService: QueryStringParamService,
    private _authService: AuthService
  ) {
    this._apiService = apiService;
  }

  public profileDropMember(profileId: number, dropSettings: DropSettingsSimple): Promise<DropMemberResult> {
    return this._apiService.post(`profile/${profileId}/membership/drop`, dropSettings);
  }

  public membersToDrop(
    queryParams: BatchDropRequestParamsDto,
    ignoreCache: boolean = false
  ): Promise<PagedResultGeneric<BatchDropRequestDto>> {
    if (!queryParams.Object) {
      delete queryParams.Object;
    }
    if (!ignoreCache) {
      return this._apiService.get('membership/memberstodrop' + this._queryStringParamService.deserializeObjectToParams(queryParams));
    } else {
      return this._apiService.get(
        'membership/memberstodrop' + this._queryStringParamService.deserializeObjectToParams(queryParams),
        this._apiService.getDefaultApiCacheOptionsForNoCache()
      );
    }
  }

  public dropMembers(ids: Array<number>, settingBatch?: string) {
    let queryParams = '?ids=' + ids.join('&ids=');
    if (settingBatch) {
      queryParams += '&settingbatch=' + settingBatch;
    }
    return this._apiService.delete('membership/batch' + queryParams);
  }

  public exportMembersCsv(ignoreIds: Array<number>, search: BatchDropRequestParamsDto) {
    return this._apiService.post(`Membership/MembersToDrop/Export`, search);
  }

  public validateProfileDrop(profileId: number, dropSettings: DropSettingsSimple): Promise<MemberDropValidationResultDto> {
    return this._apiService.post(`profile/${profileId}/membership/drop/validation`, dropSettings);
  }
}
